import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography, Grid } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import Image from '../../components/Image';
// sections
import { LoginForm } from '../../sections/auth/login';

import logoSamtech from '../../assets/SHP_logo.png';
import iconSamtech from '../../assets/iso_colores.png';
import backSide from '../../assets/bg-empresa.jpg';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  backgroundImage: `url(${backSide}); no repeat;`,
  backgroundSize: 'cover',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const LogoStyle = styled('div')(({ theme }) => ({
  width: '200px',
  display: 'flex',
  height: '10px',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(5, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuth();

  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  return (
    <Page title="Login">
      <RootStyle>
        {/* <HeaderStyle>
          <Logo />
        </HeaderStyle> */}

        {mdUp && (
          <SectionStyle
          // style={{
          //   backgroundImage: `url(${backSide})`,
          //   /* transform: 'scaleX(-1)' */
          // }}
          />
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h4" gutterBottom>
                  Bienvenido a Samtech
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}> OT - MEL</Typography>
              </Box>

              <Tooltip title={capitalCase(method)} placement="right">
                <>
                  <Image disabledEffect src={iconSamtech} sx={{ width: 50, height: 50 }} />
                </>
              </Tooltip>
            </Stack>

            <LoginForm />

            <Grid container justifyContent="center" alignItems="center">
              <a href="https://www.samtech.cl/">
                <LogoStyle>
                  <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                    <img className="logoOne" src={logoSamtech} alt="Logo" />
                  </Typography>
                </LogoStyle>
              </a>
            </Grid>
            {smUp && (
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Copyright SAMTECH © 2022
              </Typography>
            )}
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
